import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "class-name"
};
const _hoisted_2 = {
  class: "logo-container"
};
const _hoisted_3 = {
  key: 0,
  class: "logo-title"
};
import SidebarMenu from './SidebarMenu.vue';
export default {
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_avatar, {
        size: "44",
        shape: "square",
        src: "https://m.imooc.com/static/wap/static/common/img/logo-small@2x.png"
      }), _ctx.$store.getters.sidebarOpened ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "imooc-admin")) : _createCommentVNode("", true)]), _createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(SidebarMenu)]),
        _: 1
      })]);
    };
  }
};